import {Component, OnDestroy, OnInit} from '@angular/core';
import {GridApi, GridOptions} from 'ag-grid-community';
import {BehaviorSubject} from 'rxjs';
import {takeWhile} from 'rxjs';
import {FrtRatesBidcyclesService} from '../../services/frt-rates-bidcycles/frt-rates-bidcycles.service';
import {UntypedFormBuilder} from '@angular/forms';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-extend-expiry-dates',
    templateUrl: './extend-expiry-dates.component.html',
    styleUrls: ['./extend-expiry-dates.component.css'],
    standalone: false
})
export class ExtendExpiryDatesComponent implements OnInit, OnDestroy {
  businessType: string;
  showGrid: boolean;
  public columnDefs;
  public rowData = [];
  public rowDataMaster;
  rowData$ = new BehaviorSubject(this.rowData);
  public defaultColDef;
  hhgExtendRatesOptions: GridOptions;
  private gridApi!: GridApi<any>;
  public overlayNoRowsTemplate;
  observer$ = new BehaviorSubject(true);

  constructor(
    private frtRatesBidcyclesService: FrtRatesBidcyclesService,
    private fb: UntypedFormBuilder,
    private alertService: AlertService,
    private tmssLoader: LoadingService,
    private bsModalRef: BsModalRef,
  ) {
    this.showGrid = true;
    this.overlayNoRowsTemplate = '<span>No BidCycles. Please adjust your query options.</span>';
  }

  /**
   * initializing the grid
   */
  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 50,
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 25,
      domLayout: 'autoHeight',
      onGridReady: params => {
        this.gridApi = params.api;
        params.api.sizeColumnsToFit();
      },
      suppressRowClickSelection: true,
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
    };
  }

  /**
   * @description fetches the extend rates based on businesstype; sets the grid options.
   */
  ngOnInit() {
    this.frtRatesBidcyclesService.getExtendRates(this.businessType).pipe(takeWhile(() => this.observer$.value)).subscribe((data: any) => {
      this.rowData = data;
      this.rowDataMaster = data;
      this.tmssLoader.hide();
    }, error => {
      this.tmssLoader.hide();
      this.alertService.error('Error retrieving Extend Rates.');
    });
    this.columnDefs = [
      {
        headerName: 'Select',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true
      },
      {
        headerName: 'Rate Type',
        field: 'rateType',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Sro ID',
        field: 'sroId',
        filter: 'agTextColumnFilter',
      },
      {
        headerName: 'Rate Effective Date',
        field: 'rateEffective',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Rate Expiry Date',
        field: 'rateExpiry',
        filter: 'agTextColumnFilter',
        // cellEditor: 'agRichSelectCellEditor',
        editable: function(params) {
          if (params.node.selected) {
            return true;
          }
          return false; // true/false based on params (or some other criteria) value
        }
      }
    ];
    this.hhgExtendRatesOptions = this.initializeGridOptions();
  }

  /**
   * @description updates all the rates edited  in the frid based on business type.
   */
  extendRates() {
    const payload = this.gridApi.getSelectedRows();
    this.frtRatesBidcyclesService.updateExtendRates(this.businessType, payload)
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(res => {
        this.tmssLoader.hide();
        this.alertService.success('Your request has been received. Please check after sometime.');
      }, error => {
        this.tmssLoader.hide();
        this.alertService.error('Error while processing your request. Please contact system administrator.');
      });
  }

  /**
   * @description resets the ag-grid with the data retrieving the API: discards all the cell editing changes.
   */
  resetRates() {
    this.rowData = this.rowDataMaster;
    this.showGrid = false;
    setTimeout(() => {
      this.showGrid = true;
    });
  }
  /**
   * @description closes the modal using ng bootstrap as the injector is local to the component class
   */
  closeModal() {
    this.bsModalRef.hide();
  }
  /**
   * @description sets the subject to false to unsubscribe to all the subscriptions
   */
  ngOnDestroy(): void {
    this.observer$.next(false);
  }

}
